import React from 'react';
import {Stack} from '@mui/material';
import {
  Body,
  designSystemToken,
  Headline,
} from '@lightricks/react-design-system';
import styles from './CreatorInfo.module.scss';

type CreatorInfoProps = {
  fullName: string;
  handle?: string | null;
  age?: string;
  location?: string;
  nameAdornment?: React.ReactNode;
};

function CreatorInfo({
  fullName,
  handle,
  age,
  location,
  nameAdornment,
}: CreatorInfoProps) {
  const displayHandle = handle?.trim();
  const subtitle = [age, location].filter(Boolean).join(' | ');
  return (
    <Stack direction="column" className={styles.creatorContentContainer}>
      <div className={styles.nameRow}>
        <div className={styles.nameCluster}>
          <span className={styles.fullNameSlot}>
            <Headline
              size="md"
              color={designSystemToken('semantic.fg.primary')}
              className={styles.fullName}
            >
              {fullName}
            </Headline>
          </span>
          {nameAdornment ? (
            <span className={styles.nameAdornment}>{nameAdornment}</span>
          ) : null}
        </div>
      </div>
      {displayHandle ? (
        <Body
          size="sm"
          color={designSystemToken('semantic.fg.secondary')}
          className={styles.subtitle}
        >
          {displayHandle}
        </Body>
      ) : null}
      <Body
        size="sm"
        color={designSystemToken('semantic.fg.primary')}
        className={styles.subtitle}
      >
        {subtitle}
      </Body>
    </Stack>
  );
}

export default CreatorInfo;
